import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, XCircle } from 'lucide-react';

const PaymentCanceled: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="croop-route-page">
      <div className="croop-route-panel">
        <div className="croop-route-brand" aria-label="Croop">
          <img className="croop-route-logo" src="/croop-horizontal.svg" alt="" />
        </div>

        <div className="croop-route-icon croop-route-icon-canceled">
          <XCircle size={46} />
        </div>

        <h1 className="croop-route-title">
          Payment canceled
        </h1>

        <p className="croop-route-copy">
          No charge was made. You can try again whenever you are ready.
        </p>

        <button
          type="button"
          className="croop-primary-button"
          onClick={() => navigate('/')}
        >
          <ArrowLeft size={18} />
          Back to Croop
        </button>
      </div>
    </div>
  );
};

export default PaymentCanceled;
